/*global Ractive*/
module.exports = function createPaginationComponent() {
	return Ractive.extend({
		template: require('./index.html'),
		data() {
			return {
				items: [],
				class: '',
				currentPageNumber: 1,
				perPageCount: 0,
				currentPageItems: [],
				totalItemsCount: 0,
				showInfoFooter: false,
			}
		},
		attributes: {
			required: [ 'items', 'perPageCount', 'currentPageNumber', 'currentPageItems' ],
			optional: [ 'class', 'totalItemsCount', 'showInfoFooter' ],
		},
		css: `
		@media screen and (max-width: 576px) {
			.hideOnMobile {
				display: none;
			}
			.pagination-sm .page-link {
				padding: 0.5rem 0.75rem;
				font-size: 1rem
				line-height: 1.25;
			}
			.arrowWidth {
				width: 39px
			}
		}
		@media screen and (min-width: 576px){
			.arrowWidth {
				width: 31px
			}
		}
		`,
		computed: {
			pages() {
				const items = this.get('items')
				const totalItemsCount = this.get('computedTotalItemsCount')
				let perPageCount = parseInt(this.get('perPageCount'), 10)

				if (items && Array.isArray(items) && perPageCount) {
					perPageCount = parseInt(perPageCount, 10)
					const pagesCount = Math.ceil(totalItemsCount / perPageCount)

					let pages = []
					let n = 1

					while (n <= pagesCount) {
						pages.push({
							number: n,
							startIndex: n === 1 ? 0 : perPageCount * (n - 1),
							endIndex: perPageCount * n,
						})
						n++
					}

					return pages
				}
				return []
			},
			displayPages() {
				const pages = this.get('pages')

				if (!pages?.length) {
					return []
				}

				const currentPageNumber = this.get('currentPageNumber')
				const lastPage = pages.length - 1
				const mobileSize = this.isMobileSize()
				this.set('mobileSize', mobileSize)

				return pages?.reduce((sum, page) => {
					if (!(lastPage <= 7
						|| page.number === currentPageNumber // current page always
						|| (page.number <= 5 && currentPageNumber <= 4) // current page in beginning of list
						|| (page.number > currentPageNumber - 2 && page.number < currentPageNumber + 2) // one on either side of current
						|| (page.number >= lastPage - 3 && currentPageNumber >= lastPage - 2))
					) {
						page.hideOnMobile = true
					} else {
						page.hideOnMobile = false
					}
					if (lastPage <= 9
						|| currentPageNumber == page.number // current page
						|| (page.number <= 7 && currentPageNumber <= 4) // beginning of list
						|| (page.number > currentPageNumber - 3 && page.number < currentPageNumber + 3) // middle of list
						|| (page.number > lastPage - 6 && currentPageNumber > lastPage - 3) // end of list
					) {
						return sum.concat(page)
					}
					return sum
				}, [])
			},
			lastPage() {
				const pages = this.get('pages')

				return pages ? pages.length : null
			},
			computedTotalItemsCount() {
				const items = this.get('items')
				const totalItemsCount = this.get('totalItemsCount')
				if (totalItemsCount) {
					return totalItemsCount
				} else if (items && Array.isArray(items)) {
					return items.length
				}
				return 0
			},
			showPagination() {
				const perPageCount = this.get('perPageCount')
				const totalItemsCount = this.get('computedTotalItemsCount')

				return perPageCount && (totalItemsCount > parseInt(perPageCount, 10))
			},
			buttonWidth() {
				const lastPage = this.get('lastPage')
				const mobileSize = this.get('mobileSize') || this.isMobileSize()
				if (mobileSize) {
					return lastPage >= 100 ? 51 : lastPage >= 10 ? 40 : 34
				}
				return lastPage >= 100 ? 40 : lastPage >= 10 ? 34 : 28
			},
			numPagesHiddenOnMobile() {
				const displayPages = this.get('displayPages')
				if (!displayPages?.length) {
					return 0
				}

				return displayPages.reduce((sum, page)=> {
					if (page.hideOnMobile) {
						return sum++
					}
					return sum
				}, 0)
			},
			somePagesHidden() {
				const pagesLength = this.get('pages')?.length
				const displayPagesLength = this.get('displayPages')?.length
				const numPagesHiddenOnMobile = this.get('numPagesHiddenOnMobile')
				const mobileSize = this.get('mobileSize')
				return ((displayPagesLength < pagesLength) || (mobileSize && numPagesHiddenOnMobile))
			},
		},
		isMobileSize() {
			const { matches } = window.matchMedia('(max-width: 576px)')
			return matches
		},
		setPageVisibleByItemIndex(itemIndex) {
			const ractive = this

			const foundPage = ractive.get('pages').find(page => {
				return itemIndex >= page.startIndex && itemIndex < page.endIndex
			})

			if (foundPage && foundPage.number !== ractive.get('currentPageNumber')) {
				ractive.set('currentPageNumber', foundPage.number)
			}
		},
		oninit() {
			const ractive = this

			ractive.on('first-page-clicked', () => {
				ractive.set({ currentPageNumber: 1 })
				ractive.fire('pageChange', { pageNumber: 1 })
			})

			ractive.on('previous-page-clicked', () => {
				const pageNumber = ractive.get('currentPageNumber') - 1
				ractive.set({ currentPageNumber: pageNumber })
				ractive.fire('pageChange', { pageNumber })
			})

			ractive.on('page-clicked', (context, pageNumber) => {
				ractive.set({ currentPageNumber: pageNumber })
				ractive.fire('pageChange', { ...context, pageNumber })
			})

			ractive.on('last-page-clicked', () => {
				const pageNumber = ractive.get('lastPage')
				ractive.set({ currentPageNumber: pageNumber })
				ractive.fire('pageChange', { pageNumber })
			})

			ractive.on('next-page-clicked', () => {
				const pageNumber = ractive.get('currentPageNumber') + 1
				ractive.set({ currentPageNumber: pageNumber })
				ractive.fire('pageChange', { pageNumber })
			})

			ractive.observe('items pages currentPageNumber', () => {
				let items = ractive.get('items')
				const perPageCount = ractive.get('perPageCount')
				items = items ? items : []

				const pages = ractive.get('pages')
				const currentPageNumber = ractive.get('currentPageNumber')

				if (pages && pages.length < currentPageNumber) {
					ractive.set('currentPageNumber', pages.length > 0 ? pages.length : 1)
				}

				const currentPage = (pages && pages.length > 0 && items.length > perPageCount) ? pages.find(page => page.number === currentPageNumber) : null

				const currentPageItems = currentPage
					? items.slice(currentPage.startIndex, currentPage.endIndex) : items

				ractive.set({ currentPageItems })
			})
		},
	})
}
